declare const APP_RELEASE: string;

export const release: string = APP_RELEASE;
